export const MuiTextField = {
  styleOverrides: {
    root: {
      // SKIM to do: Do we want this to be 10px or another value within our system?
      // Do we want to creating a spacing/padding system, or use MUI's?
      marginBottom: "10px",
    },
  },
};
